import { colors } from '@/components/atoms/colors'
import MahimaLogo from '@/components/atoms/mahimaLogo'
import Link from 'next/link'

const ButtonDefault = () => {
  const base =
    'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90px] lg:w-[165px] aspect-[12/5] z-[3] pointer-events-auto'
  return (
    <Link scroll={false} href="/" className={base}>
      <MahimaLogo color={colors.olive} className="w-full h-full" />
    </Link>
  )
}

export default ButtonDefault
